export interface ContactIdentifier {
  id: string;
  role: string;
}

export interface ChampionshipContact {
  championshipId: string;
  contactIdentifiers: ContactIdentifier[];
}

export enum UserRole {
  Player = 0,
  Manager = 1,
  Caddie = 2,
  LCQPlayer = 5,
  LCQCaddie = 6,
  LCQManager = 7,
  RandaAdmin = 99,
}

export const ContactRolesByPriority = {
  [UserRole.LCQCaddie]: 0,
  [UserRole.Caddie]: 1,
  [UserRole.LCQPlayer]: 2,
  [UserRole.Player]: 3,
  [UserRole.LCQManager]: 4,
  [UserRole.Manager]: 5,
};

export const RoleNameMap: Record<UserRole, string> = {
  [UserRole.Player]: 'player',
  [UserRole.Manager]: 'manager',
  [UserRole.Caddie]: 'caddie',
  [UserRole.LCQPlayer]: 'lcq - player',
  [UserRole.LCQCaddie]: 'lcq - caddie',
  [UserRole.LCQManager]: 'lcq - manager',
  [UserRole.RandaAdmin]: 'randaadmin',
};
